<template>
  <UIDialog
    :is-open
    :z-index
    size="2md"
    title="Settings"
    @close="handleClose"
  >
    <UITabs v-model="tab" :tabs />
    <div v-if="tab === SettingTabs.COMMON" class="settings-page__tab">
      <CommonSettings />
    </div>
    <div v-if="tab === SettingTabs.ACCOUNT" class="settings-page__tab">
      <AccountSettings />
    </div>
    <div v-if="tab === SettingTabs.ANALYTICS" class="settings-page__tab">
      <AnalyticsSettings />
    </div>
  </UIDialog>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { SettingTabs } from './utils/enums'
import { ModalClass } from '@types'

import { UIDialog } from '@ui/modals'
import { UITabs } from '@ui/core'

import CommonSettings from './Common/Common.vue'
import AccountSettings from './Account/Account.vue'
import AnalyticsSettings from './Analytics/Analytics.vue'

type Props = {
  modal: ModalClass<any>
  tab?: SettingTabs
}

const props = defineProps<Props>()

const tab = ref<SettingTabs>(SettingTabs.COMMON)

const tabs = computed(() =>
  Object.values(SettingTabs).map(name => ({
    name,
  })),
)

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.close()
}

watch(
  isOpen,
  value => {
    if (!value) return
    tab.value = props.tab || SettingTabs.COMMON
  },
  { immediate: true },
)
</script>

<style>
.settings-page {

  &__tab {
    @apply flex flex-col;
    @apply gap-4 pb-4;
  }
}
</style>
